import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { CosmosCrest } from '@/components/brand/CosmosCrest'

export function NotFoundPage() {
  return (
    <div className="py-32 grid place-items-center text-center px-6">
      <CosmosCrest size={140} />
      <div className="font-display text-8xl mt-6 num text-cosmos-green">404</div>
      <h1 className="mt-2 font-display text-3xl uppercase">Off Sides.</h1>
      <p className="mt-3 text-muted-foreground max-w-md">
        This page isn't part of the Cosmos F.C. squad. Try one of the routes from the nav — or head home.
      </p>
      <Button asChild className="mt-6"><Link to="/">Back to Home</Link></Button>
    </div>
  )
}
